import debugcfg from './debug.json'
import prodcfg from './production.json'

const cfg = process.env.NODE_ENV === 'production'? prodcfg : debugcfg

export default {
    // SERVER_URL : cfg.SERVER_URL
    ...cfg
}
